/* One set page selects and adds three real, independently sized artworks. */
(() => {
  if (customElements.get('joffz-gallery-set')) return;
  class JoffzGallerySet extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.scope = this.closest('.product__info-container') || this;
      this.form = this.scope.querySelector('[data-set-form]');
      if (!this.form) return;
      try { this.config = JSON.parse(this.scope.querySelector('[data-set-config]').textContent); }
      catch (_) { return; }
      this.products = this.config.products;
      this.labels = this.config.labels;
      this.button = this.scope.querySelector('[data-add]');
      this.status = this.scope.querySelector('[data-status]');
      this.viewBag = this.scope.querySelector('[data-view-bag]');
      this.quantityInput = this.scope.querySelector('[data-quantity]');
      this.selects = [...this.scope.querySelectorAll('[data-size]')];
      this.format = new Intl.NumberFormat(this.config.locale, { style: 'currency', currency: this.config.currency });
      this.pendingKey = 'joffz-gallery-pending-' + this.config.id;
      this.finishSelects = [...this.scope.querySelectorAll('select[data-finish]')];
      this.scope.addEventListener('change', event => {
        if (!this.locked) this.status.textContent = '';
        this.render();
      });
      this.quantityInput.addEventListener('input', () => this.render());
      this.form.addEventListener('submit', event => { event.preventDefault(); this.addSet(); });
      if (this.products.length !== 3 || this.selects.length !== 3 || this.finishSelects.length !== 3) {
        this.locked = true; this.status.textContent = this.labels.config_error;
      }
      let pending = null;
      try { pending = JSON.parse(sessionStorage.getItem(this.pendingKey)); } catch (_) { /* storage can be unavailable */ }
      if (pending) {
        this.locked = true;
        this.status.textContent = this.labels.unknown_error;
        this.viewBag.hidden = false;
      }
      this.render();
    }
    selectedVariants() {
      return this.products.map((p, i) => p.variants.find(v => v.options[0] === this.finishSelects[i].value && v.options[1] === this.selects[i].value));
    }
    quantity() { return Number(this.quantityInput.value); }
    validQuantity() { const q = this.quantity(); return Number.isInteger(q) && q >= 1 && q <= 10; }
    money(cents) {
      const format = this.config.moneyFormat || '';
      const token = format.match(/\{\{\s*(\w+)\s*\}\}/);
      const styles = {amount:[2,',','.'],amount_no_decimals:[0,',','.'],amount_with_comma_separator:[2,'.',','],amount_no_decimals_with_comma_separator:[0,'.',','],amount_with_apostrophe_separator:[2,"'",'.'],amount_with_space_separator:[2,' ',','],amount_no_decimals_with_space_separator:[0,' ',',']};
      const style = token && styles[token[1]];
      if (!style) return this.format.format(cents / 100);
      const parts = (cents / 100).toFixed(style[0]).split('.');
      const amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, style[1]) + (parts[1] ? style[2] + parts[1] : '');
      return format.replace(token[0], amount);
    }
    render() {
      this.scope.querySelectorAll('.joffz-gallery-artwork fieldset').forEach(fieldset => { fieldset.disabled = Boolean(this.busy || this.locked); });
      this.scope.querySelectorAll('[data-finish], [data-size], [data-quantity]').forEach(control => { control.disabled = Boolean(this.busy || this.locked); });
      this.products.forEach((p, i) => {
        [...this.finishSelects[i].options].forEach(option => { option.disabled = !p.variants.some(v => v.options[0] === option.value && v.available); });
        [...this.selects[i].options].forEach(option => {
          const variant = p.variants.find(v => v.options[0] === this.finishSelects[i].value && v.options[1] === option.value);
          option.disabled = !variant || !variant.available;
        });
      });
      const selected = this.selectedVariants();
      const available = selected.length === 3 && selected.every(v => v && v.available);
      selected.forEach((v, i) => { this.scope.querySelector('[data-artwork-price="' + i + '"]').textContent = v ? this.money(v.price) : '—'; });
      this.unitTotal = selected.reduce((sum, v) => sum + (v ? v.price : 0), 0);
      this.scope.querySelector('[data-total]').textContent = available && this.validQuantity() ? this.money(this.unitTotal * this.quantity()) : '—';
      const experience = this.scope.querySelector('joffz-product-experience');
      const allPosters = this.finishSelects.every((s, i) => s.value === this.products[i].finishes[0]);
      if (experience) { experience.dataset.materialValue = allPosters ? 'Poster' : ''; const specs = experience.querySelector('[data-paper-specs]'); if (specs) specs.hidden = !allPosters; }
      this.button.disabled = Boolean(this.busy || this.locked || !available || !this.validQuantity());
      this.button.querySelector('[data-add-label]').textContent = this.busy ? this.labels.adding : available ? this.labels.add : this.labels.unavailable;
      this.button.classList.toggle('loading', Boolean(this.busy));
      this.button.setAttribute('aria-busy', String(Boolean(this.busy)));
    }
    async readJson(url, options) {
      const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options });
      const result = await response.json();
      return { response, result };
    }
    endpoint(path) { return this.config.root.replace(/\/?$/, '/') + path; }
    async refreshSelection(selected) {
      const fresh = await Promise.all(this.products.map(p => this.readJson(this.endpoint('products/' + encodeURIComponent(p.handle) + '.js'))));
      let changed = false;
      fresh.forEach(({response, result}, i) => {
        if (!response.ok || !Array.isArray(result.variants)) throw new Error('refresh');
        this.products[i].variants.forEach(v => {
          const latest = result.variants.find(n => String(n.id) === String(v.id));
          v.available = Boolean(latest && latest.available);
          if (latest) v.price = latest.price;
        });
        const latest = result.variants.find(v => String(v.id) === String(selected[i].id));
        if (!latest || !latest.available) changed = true;
        else if (latest.price !== selected[i].price) changed = true;
      });
      return changed;
    }
    remember(group) { try { sessionStorage.setItem(this.pendingKey, JSON.stringify({ group, at: Date.now() })); } catch (_) { /* do not retry automatically */ } }
    forget() { try { sessionStorage.removeItem(this.pendingKey); } catch (_) { /* optional storage */ } }
    async reconcile(group) {
      try {
        const {response, result} = await this.readJson(this.endpoint('cart.js'));
        if (!response.ok) return null;
        return (result.items || []).filter(item => item.properties && item.properties._joffz_gallery_group === group);
      } catch (_) { return null; }
    }
    async addSet() {
      if (this.busy || this.locked || !this.validQuantity()) return;
      const selected = this.selectedVariants().map(v => v && ({ ...v }));
      if (selected.some(v => !v || !v.available)) return;
      this.busy = true; this.status.textContent = ''; this.render();
      try {
        const changed = await this.refreshSelection(selected);
        this.render();
        if (changed) { this.status.textContent = this.labels.price_changed; return; }
      } catch (_) { this.status.textContent = this.labels.refresh_error; this.busy = false; this.render(); return; }
      finally { this.busy = false; this.render(); }
      if (this.status.textContent) return;
      this.busy = true; this.render();
      const group = globalThis.crypto?.randomUUID?.() || ('gws-' + Date.now() + '-' + Math.random().toString(36).slice(2));
      const quantity = this.quantity();
      const items = selected.map((v, i) => ({
        id: Number(v.id), quantity,
        properties: { [this.labels.group_label]: this.config.title, [this.labels.artwork_label]: String(i + 1) + '/3', _joffz_gallery_group: group, _joffz_gallery_parent: String(this.config.id) }
      }));
      this.remember(group);
      let response, result;
      try { ({response, result} = await this.readJson(this.endpoint('cart/add.js'), { method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items}) })); }
      catch (_) {
        const added = await this.reconcile(group);
        this.locked = true; this.viewBag.hidden = false;
        this.status.textContent = added && added.length === 3 && added.every(i => i.quantity === quantity) ? this.labels.success : this.labels.unknown_error;
        this.busy = false; this.render(); return;
      }
      if (!response.ok) {
        const added = await this.reconcile(group);
        if (added && added.length === 0) {
          this.forget(); this.status.textContent = this.labels.add_error;
        } else {
          this.locked = true; this.viewBag.hidden = false; this.status.textContent = this.labels.partial_error;
        }
        this.busy = false; this.render(); return;
      }
      const added = result.items;
      if (!Array.isArray(added) || added.length !== 3 || added.some(i => i.quantity !== quantity)) {
        this.locked = true; this.viewBag.hidden = false; this.status.textContent = this.labels.partial_error;
        this.busy = false; this.render(); return;
      }
      this.forget(); this.locked = true; this.busy = false; this.render();
      this.status.textContent = this.labels.success; this.viewBag.hidden = false;
      location.assign(this.config.cartUrl + '?view=page');
    }
  }
  customElements.define('joffz-gallery-set', JoffzGallerySet);
})();